// extracted by mini-css-extract-plugin
export default {"description":"Description_description__oaXMC","title":"Description_title__8zmIy","text":"Description_text__+d85c"};